const columns = [
  {
    title: 'Subject',
    dataIndex: 'subject',
  },
  {
    title: 'Users',
    dataIndex: 'count',
  },
  {
    title: 'Date',
    dataIndex: 'createdDate',
  },
];

export default columns;